
export default {
  title: '职位列表',
  talent: '才能',
  opportunity: '机会',
  viewJobs: '查看职位',
  notSpecified: '不限',
  multiLocations: '多城市',
  internalJob: '内部职位',
  externalJob: '外部职位',
  tip: {
    noJobMatched: '抱歉！暂无此类工作',
    tryOtherKeywords: '请尝试搜索其他关键词 :)',
    groupJobTips: '*您只能申请一个福特校招职位，请谨慎选择。此申请请使用英文简历。'
  },
  label: {
    referralRewards: '推荐奖励',
    availableJobs: '招聘职位',
    openJobCount: '共开放{count}个职位',
    locationsText: '{city} 等<span class="num">{count}</span>个地址',
    locationsTitleText: '{city} 等{count}个地址',
    detailPageTitleText: '{name}|寻找最佳候选人!'
  },
  btn: {
    winRewards: '赢奖励',
    search: '搜索',
    apply: '申请',
    reapply: '重新申请',
    applied: '已申请',
    continueFinishApply: '继续完成申请',
    follow: '加关注',
    stopFollowing: '停止关注'
  },
  message: {
    multipleJobs: '多职位',
    multipleLocations: '多地点'
  }
}
